import { VOtpInput } from 'vuetify/lib/components/VOtpInput';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "onboard-shared-otp-input",
    class: _vm.size
  }, [_c(VOtpInput, {
    ref: "otpInput",
    attrs: {
      "length": _vm.length,
      "type": _vm.type,
      "disabled": _vm.disabled,
      "inputmode": _vm.inputMode
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: _vm.otpValue,
      callback: function ($$v) {
        _vm.otpValue = $$v;
      },
      expression: "otpValue"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };